module.exports = __webpack_public_path__ + "img/smile.a685690a.png";